  const sortCaret = (order, column) => {
    if (!order) return <span>&nbsp;&nbsp;⇅</span>;
    else if (order === 'asc') return <span>&nbsp;&nbsp;↑</span>;
    else if (order === 'desc') return <span>&nbsp;&nbsp;↓</span>;
    return null;
  };
  
  export default sortCaret;